
let host = 'http://chrcmp.chinahr.com';
if (process.env.NODE_ENV == 'development') {
    host = 'http://localhost:8103';
}

const apis = {
    'loadPagePropsByCode': `${host}/cmp/page/data`
};
export function loadPagePropsByCode(domain, code) {
    return fetch(`${apis.loadPagePropsByCode}/${domain}/${code}`)
        .then((res) => res.json())
        .then((res) => {
            if (res.code == 1) {
                return res.data || {};
            } else {
                return {};
            }
        });
}


// WEBPACK FOOTER //
// ./_source/cqsx/services/page-model/service.js